import React, { forwardRef, useContext, useEffect, useRef } from 'react';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../../config/Pages';
import { inputsDadosGerais } from '../../PageInputs';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import { InputTextarea } from 'primereact/inputtextarea';
import AutoCompleteDropDown from '../../../../../core/components/inputs/AutoCompleteDropDown';
import { InputText } from 'primereact/inputtext';
import Buttons from '../Buttons';
import Vinculos from './Vinculos';
import InputNomeIndicador from '../inputNomeIndicador/InputNomeIndicador';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import FieldWithInfo from '../FieldWithInfo';
import PageMessages from '../../../../../config/translations/PageMessages';
import { MultipageContext } from '../../../../../core/components/Multipage';
import { isEmpty } from '../../../../../core/utils/ValidForm';
import { useOrgao, useUsuarioLogado } from '../../../Utils';
import Shareds from '../../../../../config/translations/Shareds';
import { useHistory } from 'react-router-dom';
import { assignRefs } from '../../../../../core/utils/Global';
import Validations from '../../../../../config/translations/Validations';
import { useInputs } from '../../../../../core/utils/Hooks';
import propostaIndicadorService from '../../../../../service/PropostaIndicadorService';
import pessoaIntegracaoService from '../../../../../service/integracao/PessoaIntegracaoService';
import unidadeOrcamentariaIntegracaoService from '../../../../../service/integracao/UnidadeOrcamentariaIntegracaoService';
import orgaoIntegracaoService from '../../../../../service/integracao/OrgaoIntegracaoService';
import tipoIndicadorService from '../../../../../service/TipoIndicadorService';
import subtipoIndicadorService from '../../../../../service/SubtipoIndicadorService';
import indicadorService from '../../../../../service/IndicadorService';
import styles from '../Utils.module.scss';

function FormDadosGerais({ onSave, isView, onVoltar, disableButtonVoltar, onFind }, ref) {
    const { idProposta, confirmRef, voltarUrl, idIndicador } = useContext(MultipageContext);
    const formRef = useRef(null);
    const vinculosRef = useRef(null);
    const tipoIndicadorRef = useRef(null);
    const desdobramentoRef = useRef(null);
    const user = useUsuarioLogado();
    const history = useHistory();
    const { nmIndicador } = useInputs(inputsDadosGerais);
    const unidadeOrcamentariaRef = useRef(null);
    const orgaoUsuarioLogado = useOrgao();
    const dadosIndicadorRef = useRef(null);

    useEffect(() => {
        if (!isEmpty(idProposta)) {
            formRef.current?.onLoad();
        }
    }, []);

    const Inputs = ({ formik, formController }) => (
        <form
            onSubmit={formik.handleSubmit}
            className="p-col-12 p-grid p-fluid"
            style={{ margin: '0px' }}
        >
            <FieldWithInfo
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.orgao?.idenOrgao !== formik.values?.orgao?.idenOrgao
                        ? styles.hasDiff
                        : ''
                }
                formController={formController}
                formik={formik}
                id="orgao"
                cols="12 6"
            >
                <AutoCompleteDropDown
                    field="descOrgao"
                    formik={formik}
                    service={orgaoIntegracaoService.autoComplete.bind(orgaoIntegracaoService)}
                    disabled={isView || orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                    onSelect={async (ev) => {
                        const { idenOrgao } = ev?.value ?? {};
                        const response = await unidadeOrcamentariaIntegracaoService.getByOrgao(
                            idenOrgao
                        );
                        unidadeOrcamentariaRef.current?.setLista(response);
                    }}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="unidadeOrcamentaria"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.unidadeOrcamentaria?.idenUo !==
                        formik.values?.unidadeOrcamentaria?.idenUo
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    ref={unidadeOrcamentariaRef}
                    name="unidadeOrcamentaria"
                    valueIsCompleteObject
                    formik={formik}
                    disabled={isView}
                    optionLabel="descricaoUnidadeOrcamentaria"
                    optionValue="idenUo"
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="usuarioCadastro"
                cols="12 6"
            >
                <InputText
                    disabled
                    value={
                        isEmpty(idProposta) ? user?.nomeApresentacao : formik.values.usuarioCadastro
                    }
                    onChange={formik.handleChange}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="responsavelIndicador"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.responsavel?.idenPessoa !==
                        formik.values?.responsavelIndicador?.idenPessoa
                        ? styles.hasDiff
                        : ''
                }
            >
                <AutoCompleteDropDown
                    field="nomePessoa"
                    formik={formik}
                    service={pessoaIntegracaoService.autoComplete.bind(pessoaIntegracaoService)}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="tipoIndicador"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.tipoIndicador?.id !==
                        formik.values?.tipoIndicador?.id
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    ref={tipoIndicadorRef}
                    formik={formik}
                    valueIsCompleteObject
                    optionLabel="descTipoIndicador"
                    callbackSetList={tipoIndicadorService.list.bind(tipoIndicadorService)}
                    onChange={async (ev) => {
                        const item = tipoIndicadorRef.current?.lista.find(
                            (el) => el?.id === ev.value
                        );

                        formik.setFieldValue('tipoIndicador', item);
                        if (
                            item?.codgTipoIndicador !== 'INDICADOR_PLANEJAMENTO' &&
                            item?.codgTipoIndicador !== 'INDICADOR_PROCESSO'
                        ) {
                            formik.setFieldValue('desdobramento', '');
                        } else {
                            const response = await subtipoIndicadorService.list(
                                isEmpty(item?.id)
                                    ? null
                                    : {
                                          params: { search: `tipoIndicador.id==${item.id}` },
                                      }
                            );
                            desdobramentoRef.current?.setLista(response);
                        }
                    }}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="desdobramento"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.subtipoIndicador?.id !==
                        formik.values?.desdobramento?.id
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    ref={desdobramentoRef}
                    formik={formik}
                    valueIsCompleteObject
                    optionLabel="descSubtipoIndicador"
                    callbackSetList={subtipoIndicadorService.list.bind(subtipoIndicadorService)}
                    disabled={
                        isView ||
                        (formik.values.tipoIndicador?.codgTipoIndicador !==
                            'INDICADOR_PLANEJAMENTO' &&
                            formik.values.tipoIndicador?.codgTipoIndicador !== 'INDICADOR_PROCESSO')
                    }
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descArea"
                cols="12 6"
                className={
                    idIndicador && dadosIndicadorRef.current?.descArea !== formik.values?.descArea
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputText
                    value={formik.values.descArea}
                    onChange={formik.handleChange}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descSubArea"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descSubArea !== formik.values?.descSubArea
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputText
                    value={formik.values.descSubArea}
                    onChange={formik.handleChange}
                    disabled={isView}
                />
            </FieldWithInfo>
            <InputNomeIndicador
                infoMessage={PageMessages.sei.propostaIndicador.inputs.nomeIndicador}
                formik={formik}
                disabled={isView}
            />
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descJustificativa"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descJustificativa !==
                        formik.values?.descJustificativa
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={500}>
                    <InputTextarea
                        value={formik.values.descJustificativa}
                        onChange={formik.handleChange}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descObjetivo"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descObjetivo !== formik.values?.descObjetivo
                        ? styles.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={300}>
                    <InputTextarea
                        value={formik.values.descObjetivo}
                        onChange={formik.handleChange}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
        </form>
    );

    return (
        <>
            <BaseForm
                ref={assignRefs(ref, formRef)}
                redirectOnSave={false}
                page={Pages.sei.propostaIndicador}
                buscarOnLoad={false}
                actionOnSave={(dados) => {
                    if (onSave) {
                        onSave(dados);
                    }

                    if (dados.success && !isEmpty(idProposta)) {
                        formRef.current?.onLoad();
                    }
                }}
                onSubmit={({ registro, ...rest }) => {
                    return propostaIndicadorService.salvar({
                        ...rest,
                        registro: {
                            ...registro,
                            vinculos: vinculosRef.current?.lista.map((el) => ({
                                ...el,
                                descVinculo: el?.descricao,
                            })),
                        },
                    });
                }}
                onBuscar={async (form) => {
                    const response = await onFind({ idProposta });

                    const dadosTratados = await propostaIndicadorService
                        .getMapper()
                        .formatToInput(response, form);

                    if (idIndicador) {
                        const responseIndicador = await indicadorService.getDadosGerais({
                            idProposta: idIndicador,
                        });
                        const dados = await propostaIndicadorService
                            .getMapper()
                            .formatToInput(responseIndicador, form);
                        dadosIndicadorRef.current = dados;
                    }

                    return {
                        ...dadosTratados,
                        usuarioCadastro: dadosTratados?.contaAcessoCadastro?.nome,
                    };
                }}
                initialValues={inputsDadosGerais.filter((input) => input?.form?.use ?? false)}
                onValidate={({ data, formController }) =>
                    isEmpty(data?.nmIndicador) && formController.getCountClick() > 0
                        ? {
                              nmIndicador: Validations.form.required.replace(
                                  '{LABEL}',
                                  nmIndicador.label
                              ),
                          }
                        : {}
                }
                prepareInitialValues={async ({
                    responsavel,
                    subtipoIndicador,
                    vinculos,
                    vinculoIndicadores,
                    orgao,
                    ...rest
                }) => {
                    if (isEmpty(idProposta)) {
                        orgao = orgaoUsuarioLogado;
                    }
                    const vinculoEmUso = Array.isArray(vinculoIndicadores)
                        ? vinculoIndicadores
                        : vinculos;
                    if (
                        !isEmpty(idProposta) &&
                        (Array.isArray(vinculoEmUso) ? vinculoEmUso : []).length !== 0
                    ) {
                        vinculosRef.current?.setLista(
                            vinculoEmUso.map(
                                ({ exercicio, instrumento, descVinculo, ...rest }) => ({
                                    ...rest,
                                    instrumento,
                                    exercicio,
                                    exercicioView: exercicio?.ano,
                                    instrumentoView: instrumento?.descInstrumento,
                                    descricao: descVinculo,
                                })
                            ),
                            true
                        );
                    }

                    if (rest?.tipoIndicador?.id) {
                        subtipoIndicadorService
                            .list(
                                isEmpty(rest?.tipoIndicador?.id)
                                    ? null
                                    : {
                                          params: {
                                              search: `tipoIndicador.id==${rest?.tipoIndicador.id}`,
                                          },
                                      }
                            )
                            .then((response) => desdobramentoRef.current?.setLista(response));
                    }

                    if (orgao?.idenOrgao) {
                        unidadeOrcamentariaIntegracaoService
                            .getByOrgao(orgao?.idenOrgao)
                            .then((response) => unidadeOrcamentariaRef.current?.setLista(response));
                    }

                    return {
                        ...rest,
                        idProposta,
                        responsavelIndicador: responsavel,
                        desdobramento: subtipoIndicador,
                        orgao,
                    };
                }}
            >
                <Inputs />
            </BaseForm>
            <Vinculos ref={vinculosRef} dadosIndicadorRef={dadosIndicadorRef} isView={isView} />
            <Buttons
                disableButtonVoltar={disableButtonVoltar}
                isView={isView}
                onVoltar={() => {
                    const voltar = () => history.push(`${voltarUrl}`);

                    let hasDiffTable =
                        vinculosRef.current?.initialTableData.length !==
                            vinculosRef.current?.lista.length ||
                        vinculosRef.current?.lista.filter((el) => isEmpty(el?.id)).length > 0;

                    if (formRef.current.verificaAlteracao() || hasDiffTable) {
                        confirmRef.current?.show(Shareds.form.dontSaveData, () =>
                            setTimeout(() => (onVoltar ? onVoltar() : voltar()), 500)
                        );
                    } else {
                        onVoltar ? onVoltar() : voltar();
                    }
                }}
                onSalvar={async () => {
                    formRef.current?.formController.addCountClick();
                    formRef.current?.formik?.submitForm();
                }}
            />
        </>
    );
}

export default forwardRef(FormDadosGerais);
